import {
    convertUniversalDateToPersianDate,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoDatePicker,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoGridTwoColumn,
    RaikoMaterialOutlinedInput,
    RaikoMoneyInputOutlined,
    RaikoNumberInputOutlined,
    RaikoSectionContainer,
    RaikoToggleOutlined,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {RouteHelper} from "../../route/RouteHelper";
import React from "react";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {CashService} from "../../serverService/cashService/CashService"
import {useAuthState} from "../../context/AuthContext";
import {useEffect, useState} from "react";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import icExcel from "../../assets/svg/microsoft-excel.svg";
import icPdf from "../../assets/svg/pdf.svg"
import {ReportBox} from "../../raikoComponents/reportBox/ReportBox";
import {doDownloadFile} from "../../util/DownloadHelper";
import {readFundName} from "../../service/localStorage/LocalStorageService";

export default function CashInfo() {

    const {fundID} = useAuthState()
    const loading = new LoadingHelper(useLoadingDispatcher())

    const cashService = new CashService()

    useEffect(() => {
        if (typeof cashService !== 'undefined') {
            getCashInfoFromServer()
        }
    }, [fundID])

    //state-start
    const [fundCode, setFundCode] = useState('')
    const [fundName, setFundName] = useState('')
    const [muxNumGroup, setMuxNumGroup] = useState('')
    const [monthlyMeetingDay, setMonthlyMeetingDay] = useState("")
    const [fixedFeeRate, setFixedFeeRate] = useState('')
    const [activityStartDate, setActivityStartDate] = useState('')
    const [minimumAmount, setMinimumAmount] = useState('')
    const [lastDay, setLastDay] = useState('')
    const [address, setAddress] = useState('')
    const [loanRequestEnabled, setLoanRequestEnabled] = useState(false)

    //state-end


    function updateInfo() {
        if (checkFieldConditions()) {
            loading.show()
            cashService.updateFundInfo(
                cashService.prepareFundInfoData(
                    fundName,
                    muxNumGroup,
                    monthlyMeetingDay,
                    fixedFeeRate,
                    activityStartDate,
                    minimumAmount,
                    lastDay,
                    address,
                    loanRequestEnabled
                ),
                fundID
            ).then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }


    function getCashInfoFromServer() {
        loading.show()

        cashService.getCashInfo(fundID)
            .then(response => {
                setFundCode(response.id)
                setFundName(response.name)
                setMuxNumGroup(response.maximumGroupNumber)
                setMonthlyMeetingDay(response.dateOfMeetingPerMonth)
                setMinimumAmount(response.minimumAmountReceivedPerMonth)
                setLastDay(response.theLastDayAllowedToReceiveSavingsPerMonth)
                setAddress(response.postalAddress)
                setActivityStartDate(convertUniversalDateToPersianDate(response.activityStartDate))
                setFixedFeeRate(response.fixedFeeRate)
                setMinimumAmount(response.minimumAmountReceivedPerMonth)
                setLoanRequestEnabled(response.loanRequestEnabled)
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function checkFieldConditions() {
        let state = true
        let message = ""
        if (fundName.trim().length === 0) {
            state = false
            message = "لطفا نام صندوق را مشخص نمایید!"
        } else if (muxNumGroup.length === 0) {
            state = false
            message = "لطفا حداکثر تعداد گروه را مشخص نمایید!"
        } else if (monthlyMeetingDay.length === 0) {
            state = false
            message = "لطفا روز جلسات ماهانه را مشخص نمایید!"
        } else if (fixedFeeRate.length === 0) {
            state = false
            message = "لطفا درصد کارمزد ثابت را مشخص نمایید!"
        } else if (activityStartDate.length !== 10) {
            state = false
            message = "لطفا تاریخ شروع فعالیت صندوق را مشخص نمایید!"
        } else if (minimumAmount.length === 0) {
            state = false
            message = "لطفا حداقل مبلغ واریز ماهانه را مشخص نمایید!"
        } else if (lastDay.length === 0) {
            state = false
            message = "لطفا آخرین روز مجاز واریز را مشخص نمایید!"
        } else if (address.length === 0) {
            state = false
            message = "لطفا آدرس صندوق را مشخص نمایید!"
        }

        if (message.length > 0)
            showWarningMessage(message)
        return state
    }


    function getRepostFromServer(type) {
        loading.show()
        cashService.getFundReport(
            fundID,
            type
        ).then(response => {
            doDownloadFile(response, `خلاصه وضعیت ${readFundName()}`, type)
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                <RaikoBreadcrumb breadCrumbItems={[
                    raikoBreadCrumbItemGenerator(
                        RouteHelper.CashInfo.name,
                        RouteHelper.CashInfo.globalUrl
                    )
                ]}/>
                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"مشخصات صندوق"}
                        hasActionButton
                        actionButtonOnclick={updateInfo}
                    >
                        <RaikoGridThreeColumn>
                            <RaikoNumberInputOutlined
                                labelText={"کد صندوق"}
                                value={fundCode}
                                setValue={setFundCode}
                                disabled={true}/>
                            <RaikoMaterialOutlinedInput
                                labelText={"نام صندوق"}
                                value={fundName}
                                setValue={setFundName}/>
                            {/*<RaikoMoneyInputOutlined
                                labelText={"حداقل مبلغ واریز پس انداز (ریال)"}
                                value={minimumAmount}
                                setValue={setMinimumAmount}/>*/}
                            <RaikoNumberInputOutlined
                                labelText={"حداکثر تعداد گروه"}
                                value={muxNumGroup}
                                setValue={setMuxNumGroup}
                            />
                            <RaikoNumberInputOutlined
                                labelText={"روز جلسات ماهانه"}
                                value={monthlyMeetingDay}
                                setValue={setMonthlyMeetingDay}
                            />

                            <RaikoNumberInputOutlined
                                labelText={"نرخ کارمزد ثابت (درصد)"}
                                value={fixedFeeRate}
                                setValue={setFixedFeeRate}
                            />
                            <RaikoMoneyInputOutlined
                                labelText={"حداقل مبلغ واریز پس انداز (ریال)"}
                                value={minimumAmount}
                                setValue={setMinimumAmount}/>

                            <RaikoDatePicker
                                label={"تاریخ شروع فعالیت"}
                                date={activityStartDate}
                                setDate={setActivityStartDate}
                            />

                            <RaikoNumberInputOutlined
                                labelText={"تاریخ آخرین روز مجاز واریز"}
                                value={lastDay}
                                setValue={setLastDay}
                            />

                            <RaikoToggleOutlined
                                checked={loanRequestEnabled}
                                setChecked={setLoanRequestEnabled}
                                labelText={"درخواست وام"}
                            />

                        </RaikoGridThreeColumn>
                        <RaikoGridOneColumn>
                            <RaikoMaterialOutlinedInput
                                labelText={"آدرس"}
                                value={address}
                                setValue={setAddress}/>
                        </RaikoGridOneColumn>
                    </RaikoSectionContainer>
                </RaikoBaseCardContainer>
                <RaikoBaseCardContainer>
                    <RaikoSectionContainer title={"دریافت گزارش جامع اطلاعات صندوق"}>
                        <RaikoGridTwoColumn>
                            <ReportBox
                                label={"EXCEL"}
                                icon={icExcel}
                                action={_ => {
                                    getRepostFromServer(ReportsItemTypes.XLSX.id);
                                }}
                            />

                            <ReportBox
                                label={"PDF"}
                                icon={icPdf}
                                action={_ => {
                                    getRepostFromServer(ReportsItemTypes.PDF.id);
                                }}
                            />
                        </RaikoGridTwoColumn>
                    </RaikoSectionContainer>
                </RaikoBaseCardContainer>

            </RaikoGridOneColumn>
        </RaikoBaseContainer>
    )
}
export const ReportsItemTypes = {
    PDF: {
        id: "PDF",
        type: "pdf"
    },
    XLSX: {
        id: "XLSX",
        type: "xlsx"
    },
}